import classNames from 'classnames';
import type { ComponentProps } from 'react';

import type Button from 'src/components/common/button/button';
import { UiKitLoadingButton } from 'src/components/common/ui-kit-loading-button';

import styles from './payment-button.module.scss';

const PaymentButton = ({
  className,
  onClick,
  ...props
}: ComponentProps<typeof Button> & {
  loading?: boolean;
  onClick?: () => void;
}) => (
  <UiKitLoadingButton
    className={classNames(styles.container, className)}
    color="secondary"
    fullWidth
    onClick={onClick}
    {...props}
  />
);

export default PaymentButton;
